import Entity from './entity'
export default class MapSetting extends Entity<number>{
    name:string;
    isActive:boolean;
  
}